<template>
	<div class="w-100 d-flex flex-column" :style="{ height: height + 'px' }">
		<header style="min-height: 30px; max-height: 30px;" class="border-bottom d-flex p-2 align-items-center">
			<div>身份：{{ isLeader ? "領隊" : "旅客" }}</div>
			<div class="ms-2">姓名：{{ getUser.name }}</div>
			<div class="ms-auto d-flex align-items-center">
				
				<button class="btn p-0 ms-2" @click="logout">
					<font-awesome-icon :icon="['fas', 'right-from-bracket']" />
				</button>
			</div>
		</header>
		<main class="page-wrapper flex-fill overflow-auto" :style="{ height: 'calc(100% - 40px - 30px)' }">
			<slot />
		</main>

		<footer class="w-100 row g-0 border-top menu-box" style="min-height: 40px; max-height: 40px; z-index: 999;">
			<div class="border-end p-2 col-3 d-flex align-items-center justify-content-center cur-point" :class="{ 'bg-main': getTagName == 'bulletin' }" @click="tagsBtn('bulletin')">公告</div>
			<div class="border-end p-2 col-3 d-flex align-items-center justify-content-center" :class="{ 'bg-main': getTagName == 'message' }" @click="tagsBtn('message')">聊天室</div>
			<div class="border-end p-2 col-3 d-flex align-items-center justify-content-center" :class="{ 'bg-main': getTagName == 'map' }" @click="tagsBtn('map')">地圖</div>
			<div class="p-2 col-3 d-flex align-items-center justify-content-center" :class="{ 'bg-main': getTagName == 'schedule' }" @click="tagsBtn('schedule')">行程</div>
		</footer>
	</div>
	<!-- Modal with tabs and forms -->
</template>
<script setup lang="ts">
	import useLeader from "~/store/Leader";
	import { useWindowSize } from "vue-window-size";
	const { width, height } = useWindowSize();
	await useLeader().getUser();
	const data = ref({
		method: useLeader().LoginInfo.method,
		effectiveType: "",
	});
	const getUser = computed({
		get() {
			return useLeader().LoginInfo;
		},
		set() {},
	});
	const isLeader = computed({
		get() {
			return useLeader().LoginInfo.method == "leader";
		},
		set() {},
	});
	const getTagName = computed(() => {
		return useRoute().query.tagsname || "bulletin";
	});
	const tagsBtn = (method: string) => {
		useRouter().push({
			name: useRoute().name,
			query: {
				tagsname: method,
			},
		});
	};
	const logout = () => {
		useRouter().replace({
			name: "LeaderGroup-loginCode",
			params: {
				loginCode: getUser.value.loginCode,
			},
		});
	};
	
	
</script>
<style lang="scss">
	html,
	body,
	#__nuxt {
		max-height: 100%;
		min-height: 100%;
		font-size:16px;
	}
</style>
